@if (title) {
    <sirius-heading [text]="title" [h]="3" textStyleSize="xs" data-cy="table-regular-title"></sirius-heading>
}
<table>
    @for (row of rows; track $index; let rowIndex = $index) {
        <tr data-cy="tr">
            @for (cell of row.cells; track $index; let colIndex = $index) {
                @if ((rowIndex === 0 && columnsNumber > 2) || colIndex === 0) {
                    <th
                        [scope]="colIndex ? 'row' : 'col'"
                        class="sir-text-style-paragraph-m-bold"
                        [innerHTML]="cell.valueHtml"
                        data-cy="th"></th>
                } @else {
                    <td class="sir-text-style-paragraph-m-default" [innerHTML]="cell.valueHtml" data-cy="td"></td>
                }
            }
        </tr>
    }
</table>
